import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";

export const FinalCTA = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const launchDate = new Date('2025-11-25T00:00:00').getTime();
      const now = new Date().getTime();
      const difference = launchDate,  now;

      if (difference > 0) {
        return {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        };
      }
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    };

    setTimeLeft(calculateTimeLeft());

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section id="final-cta" className="py-32 bg-gradient-to-b from-void via-blood/10 to-void relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-blood/20 via-transparent to-blood/20 animate-smoke" />
      
      <div className="container mx-auto px-4 text-center relative z-10 max-w-4xl">
        <h2 className="text-6xl md:text-7xl font-black mb-6 tracking-tighter">
          <span className="text-blood-bright">You don't deserve</span>
          <br />
          <span className="text-foreground">another tomorrow.</span>
        </h2>
        
        <p className="text-2xl md:text-3xl text-steel mb-8 font-light">
          Pre-order The Discipline Bible now,  or close this page and go back to your pathetic cycle of broken promises.
        </p>
        
        <p className="text-xl text-ash mb-12 italic">
          Launch Date: November 25, 2025. First edition only. No reprints. No second chances.
        </p>

        {/* Countdown Timer */}
        <div className="flex justify-center gap-4 mb-8">
          {[
            { label: 'DAYS', value: timeLeft.days },
            { label: 'HOURS', value: timeLeft.hours },
            { label: 'MINUTES', value: timeLeft.minutes },
            { label: 'SECONDS', value: timeLeft.seconds }
          ].map((item, index) => (
            <div key={index} className="bg-card/30 backdrop-blur-sm border border-blood p-4 min-w-[80px]">
              <div className="text-4xl font-black text-blood-bright">
                {item.value.toString().padStart(2, '0')}
              </div>
              <div className="text-xs text-steel uppercase tracking-widest mt-1">
                {item.label}
              </div>
            </div>
          ))}
        </div>

        {/* Scarcity Message */}
        <p className="text-blood-bright text-lg font-semibold mb-8 uppercase tracking-wide animate-flicker">
          ⚠ Limited first edition. 500 copies. Once gone, buried forever. ⚠
        </p>

        {/* Bonus Offer */}
        <div className="bg-card/20 border border-blood/50 p-8 mb-10 max-w-2xl mx-auto backdrop-blur-sm">
          <p className="text-steel text-lg mb-2">
            <span className="text-blood-bright font-bold text-2xl">PRE-ORDER EXCLUSIVE:</span>
          </p>
          <p className="text-foreground text-2xl font-semibold mb-3">
            Get "The Shame Script" Ritual Workbook FREE
          </p>
          <p className="text-muted-foreground text-base leading-relaxed">
            A 47-page confessional manual used by the most disciplined men alive. Write your sins. Read them daily. Burn it when you're worthy. Not sold separately. Not available after launch. Pre-orders only.
          </p>
        </div>

        {/* CTA Button */}
        <Button 
          size="lg"
          className="bg-blood-bright hover:bg-blood text-primary-foreground px-16 py-8 text-2xl font-bold uppercase tracking-widest animate-heartbeat shadow-[0_0_40px_rgba(220,38,38,0.6)] hover:shadow-[0_0_60px_rgba(220,38,38,0.8)] transition-all"
        >
          Start the Funeral,  Claim Your Copy
        </Button>

        <p className="text-ash text-sm mt-8 italic">
          Not for public shelves. Not for the weak. Limited to 500 first-edition copies.
        </p>
        
        <p className="text-steel text-xs mt-4 uppercase tracking-widest">
          This is not motivation. This is execution.
        </p>
      </div>
    </section>
  );
};
